"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _loginConnector = _interopRequireDefault(require("../../../login/login-connector"));
var _row = _interopRequireDefault(require("../../core/row"));
var _button = _interopRequireDefault(require("../../core/button"));
var _tierSettings = _interopRequireDefault(require("./tier-settings"));
var _tierFees = _interopRequireDefault(require("./tier-fees"));
var _addTier = _interopRequireDefault(require("./add-tier"));
var _table = _interopRequireDefault(require("../../core/table"));
var _tierFeeAdjustment = _interopRequireDefault(require("./tier-fee-adjustment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("br", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null);
var _ref3 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-left"
}, "Tier"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Included in Entry Limits"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Excludes Entries in Another Race"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Open Leadtime"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Closed Leadtime"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Ranking"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Core"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "On Calendar"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Application Closing")));
var _ref4 = /*#__PURE__*/_react.default.createElement("div", {
  className: "col-xl-1"
});
var _ref5 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-left"
}), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center",
  colSpan: 3
}, "Fees (Pence)"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Leadtime"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center",
  colSpan: 4
}, "Fee Adjustments")), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-left"
}, "Tier"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Is Free"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entry"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Late"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Levy"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Late Fees"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, " Adjustment "), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, " Amount "), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, " Default "), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, " Remove ")));
const DefaultTiers = (0, _loginConnector.default)(class extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_copyFromPreviousYear", () => {
      this.props.copyFromPreviousYear(this.props.yearID);
    });
    _defineProperty(this, "_addTier", () => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_addTier.default, {
        existingTiers: this.props.defaultTiersByYear,
        yearID: this.props.yearID
      }), _ref);
    });
  }
  render() {
    const defaultTiers = this.props.defaultTiersByYear;
    if (!defaultTiers || !defaultTiers.length) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "lg",
      type: "primary",
      onClick: () => this._copyFromPreviousYear()
    }, "Copy from ", +this.props.yearID - 1), _ref2, this._addTier());
    return /*#__PURE__*/_react.default.createElement("div", null, this._addTier(), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xl-6"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "text-primary text-xs-center"
    }, "Tier Settings for ", this.props.yearID), /*#__PURE__*/_react.default.createElement(_table.default, {
      size: "sm"
    }, _ref3, /*#__PURE__*/_react.default.createElement("tbody", null, defaultTiers.map(tier => /*#__PURE__*/_react.default.createElement(_tierSettings.default, {
      key: tier.id,
      tier: tier,
      onUpdate: this.props.onUpdate
    }))))), _ref4, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xl-5"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "text-primary text-xs-center"
    }, "Tier Fees for ", this.props.yearID), /*#__PURE__*/_react.default.createElement(_table.default, {
      size: "sm"
    }, _ref5, /*#__PURE__*/_react.default.createElement("tbody", null, defaultTiers.map(tier => [/*#__PURE__*/_react.default.createElement(_tierFees.default, {
      key: tier.id,
      tier: tier,
      onUpdate: this.props.onUpdate,
      tierRowSpan: (tier.defaultTierFeeAdjustments && tier.defaultTierFeeAdjustments.length) + 1 || 1
    }), tier.defaultTierFeeAdjustments.map((adj, i) => /*#__PURE__*/_react.default.createElement(_tierFeeAdjustment.default, {
      key: adj.id,
      feeAdjustment: adj
    }))]))))));
  }
});

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref6 = _mergeBqlQueries(_mergeBqlQueries({
  id: true,
  yearID: true,
  tierDescription: true,
  defaultTierFeeAdjustments: _mergeBqlQueries({
    id: true
  }, _tierFeeAdjustment.default.partialQueries.DefaultTierFeeAdjustment)
}, _tierSettings.default.partialQueries.DefaultTiers), _tierFees.default.partialQueries.DefaultTiers);
var _default = exports.default = (0, _reactBicycle.connect)((0, _loginConnector.default)(DefaultTiers), props => ({
  ["defaultTiersByYear(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref6
}), (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('DefaultTier.set', {
      id,
      field,
      value
    });
  },
  copyFromPreviousYear(newYear) {
    return client.update('DefaultTier.copyFromPreviousYear', {
      newYear
    });
  }
}));